import Model from "./Model";

export default class Notification extends Model {
  static type = "notifications";

  notificationDate: string;
  weekNumber: number;
}
